import { createColumns, IColumnsGroup, IGroupNames, ITableHeader } from "@/utils/ColumnsCreator";
import { computed, ComputedRef } from "vue";
import { useWindowResize } from "@/utils/useWindowSize";

const subIdHeaders: ITableHeader[] = Array.from({ length: 25 }, (_, i) => ({
    text: `Sub ID ${i + 1}`,
    sortable: false,
    value: `aff_sub${i + 1}`,
    columnsSection: 'D' as const,
    width: '120px',
}));

export const useHoldConversions = (): { headers: ITableHeader[]; getColumns: () => IColumnsGroup[]; getDefaultColumns: ComputedRef<string[]> } => {
    const headers: ITableHeader[] = [
        { text: 'ID Conversion', sortable: false, value: 'conversion_id', width: '100px', align: 'center', fixed: true },
        { text: 'Transaction ID', sortable: false, value: 'transaction_id', columnsSection: 'A', width: '140px' },
        { text: 'ID клиента', sortable: false, value: 'user_id', columnsSection: 'A', width: '110px' },
        { text: 'ID клика', sortable: false, value: 'click_id', columnsSection: 'A', width: '110px' },
        { text: 'Origin', sortable: false, value: 'conversion_origin', columnsSection: 'A', width: '90px' },
        { text: 'Type', sortable: false, value: 'type', columnsSection: 'A', width: '170px' },
        { text: 'IP сессии', sortable: false, value: 'client_ip', columnsSection: 'A', width: '130px' },
        { text: 'User Agent', sortable: false, value: 'user_agent', columnsSection: 'A', width: '200px' },
        { text: 'Referrer', sortable: false, value: 'referer', columnsSection: 'A', width: '200px' },
        { text: 'Дата клика', sortable: false, value: 'click_date', columnsSection: 'A', align: 'right', width: '150px' },
        { text: 'Дата конверсии', sortable: false, value: 'conversion_date', columnsSection: 'A', align: 'right', width: '150px' },
        { text: 'Дата апрува', sortable: false, value: 'conversion_approval_date', columnsSection: 'A', align: 'right', width: '150px' },
        { text: 'Время обработки', sortable: false, value: 'conversion_processing_time', columnsSection: 'A', width: '140px' },
        { text: 'Период продажи', sortable: false, value: 'conversion_sale_time', columnsSection: 'A', width: '130px' },
        { text: 'Дата создания', sortable: false, value: 'conversion_creation_date', columnsSection: 'A', align: 'right', width: '150px' },
        { text: 'Дата обновления', sortable: false, value: 'conversion_update_date', columnsSection: 'A', align: 'right', width: '150px' },

        { text: 'ID партнёра', sortable: false, value: 'affiliate_id', columnsSection: 'B', width: '110px' },
        { text: 'Партнёр', sortable: false, value: 'affiliate_name', columnsSection: 'B', width: '150px' },
        { text: 'ID мастера', sortable: false, value: 'master_id', columnsSection: 'B', width: '100px' },
        { text: 'Мастер', sortable: false, value: 'master_name', columnsSection: 'B', width: '150px' },
        { text: 'ID буфера', sortable: false, value: 'buffer_account_id', columnsSection: 'B', width: '100px' },
        { text: 'Имя буфера', sortable: false, value: 'buffer_account_name', columnsSection: 'B', width: '140px' },
        { text: 'ID менеджера', sortable: false, value: 'master_manager_id', columnsSection: 'B', width: '110px' },
        { text: 'Менеджер', sortable: false, value: 'master_manager_name', columnsSection: 'B', width: '150px' },

        { text: 'ID рекламодателя', sortable: false, value: 'advertiser_id', columnsSection: 'C', width: '140px' },
        { text: 'Рекламодатель', sortable: false, value: 'advertiser_name', columnsSection: 'C', width: '150px' },
        { text: 'ID менеджера', sortable: false, value: 'advertiser_manager_id', columnsSection: 'C', width: '110px' },
        { text: 'Менеджер', sortable: false, value: 'advertiser_manager_name', columnsSection: 'C', width: '150px' },
        { text: 'ID оффера', sortable: false, value: 'offer_id', columnsSection: 'C', width: '100px' },
        { text: 'Оффер', sortable: false, value: 'offer_name', columnsSection: 'C', width: '150px' },
        { text: 'ID цели', sortable: false, value: 'offer_goal_id', columnsSection: 'C', width: '100px' },
        { text: 'Цель', sortable: false, value: 'offer_goal_name', columnsSection: 'C', width: '120px' },
        { text: 'Валюта', sortable: false, value: 'offer_currency', columnsSection: 'C', width: '80px' },
        { text: 'Выплата', sortable: false, value: 'payout', columnsSection: 'C', align: 'right', width: '100px' },
        { text: 'Статус', sortable: false, value: 'offer_status', columnsSection: 'C', width: '100px' },
        { text: 'Sub ID рекламодателя', sortable: false, value: 'advertiser_subid', columnsSection: 'C', width: '170px' },

        ...subIdHeaders,
    ];

    const defaultColumns = [
        'conversion_id',
        'transaction_id',
        'user_id',
        'click_id',
        'conversion_origin',
        'type',
        'conversion_date',
        'offer_status',
        'affiliate_id',
        'affiliate_name',
        'offer_id',
        'offer_name',
        'offer_currency',
        'payout',
    ];

    const groupNames: IGroupNames = {
        A: 'Конверсия',
        B: 'Партнёр',
        C: 'Оффер',
        D: 'Sub ID партнёра',
    };

    const getDefaultColumns = computed(() => {
        const { width } = useWindowResize();
        return width.value >= 768 ? defaultColumns : defaultColumns.slice(0, 7);
    });

    const getColumns = (): IColumnsGroup[] => {
        return createColumns(headers, getDefaultColumns.value, groupNames);
    };

    return { headers, getColumns, getDefaultColumns };
};
